var exports = {
  "j0": "DirectMessageLayout.module__dmLayoutContainer___RzJ0eF",
  "Id": "DirectMessageLayout.module__dmLayoutContainerCollapsed___RzJ0eF",
  "U9": "DirectMessageLayout.module__dmListColumnOverlay___RzJ0eF",
  "eN": "DirectMessageLayout.module__dmLayoutContainerFullscreen___RzJ0eF",
  "Il": "DirectMessageLayout.module__dmListColumn___RzJ0eF",
  "qy": "DirectMessageLayout.module__contentColumn___RzJ0eF",
  "$f": "DirectMessageLayout.module__contentColumnFullscreen___RzJ0eF",
  "YE": "DirectMessageLayout.module__contentInner___RzJ0eF",
  "jk": "DirectMessageLayout.module__contentInnerFullscreen___RzJ0eF",
};

module.exports = exports;
